<style scoped lang="less">

  .wrapperImage {
    width: 100%;
    height: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    border: 1px solid #ddd;
    cursor: pointer;

    img {
      border-radius: 10px;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }

  .LiveStreaming {
    color: #fff;
    padding: 5px 12px;
    padding-left: 20px;
    position: absolute;
    background: rgba(#4D4D4D, .5);
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 2%;
    left: 2%;

    &:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: #00FF00;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
    }

    &.history:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: red;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
    }

    .line {
      position: relative;
      width: 1px;
      background: #fff;
      height: 18px;
      top: 0;
    }

    .small {
      padding-left: 4px;
      font-size: 12px;
    }
  }

  .center {
    position: absolute;
    top: 50%;
    left: 50%;
    cursor: pointer;
    transform: translate(-50%, -50%);
  }

  .subTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #fff;
    background: rgba(0, 0, 0, .6);
    position: absolute;
    bottom: 0px;
    width: 100%;
    padding: 8px;
    cursor: pointer;
  }

  .subCompany {
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #000;
    margin: 15px 0;
    cursor: pointer;
  }
</style>

<template>
  <div style="position: relative">
    <div class="wrapperImage">
      <el-image :src="info.coverImage||info.coverUrl||g.defaultImage" fit="fill" style="width: 100%;height: 100%;" lazy>
        <img :src="g.defaultImage" alt="" slot="error" style="max-width: 100%;max-height: 100%"/>
      </el-image>
    </div>
    <div class="LiveStreaming" :class="[g.isEn?'isEn':'']" v-if="!history">
      <!--      `status` int(1) DEFAULT NULL COMMENT '直播状态（ 0 初始，1 直播中,2 暂停,3 已停止）',-->
      <span class="small" style="padding-right: 4px;">{{liveStatusName(info.status)}}</span>
      <span class="line" v-if="info.number"></span>
      <span class="small" v-if="info.number">{{info.number}}{{$t('lang.观看')}}</span>
    </div>
    <div class="LiveStreaming history" v-if="history">
      <!--      `status` int(1) DEFAULT NULL COMMENT '直播状态（ 0 初始，1 直播中,2 暂停,3 已停止）',-->
      <span class="small" style="padding-right: 4px;">{{$t('lang.回放')}}</span>
      <span class="line" v-if="info.number||info.hotnum"></span>
      <span class="small" v-if="info.number||info.hotnum">{{info.number||info.hotnum}}{{$t('lang.观看')}}</span>
    </div>
    <!--      中间的按钮-->
    <img v-if="g.isSz" src="../assets/images/play.png" alt="" class="center" style="width:75px;height:67px;"/>
    <img v-else src="../assets/images/w1播放.png" alt="" class="center" style="width:75px;height:67px;"/>
    <template v-if="info.title">
      <div class="subTitle" v-if="info.title" :class="['我是title',info.title]">
        <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
          {{info.title}}
        </div>
      </div>
    </template>
    <template v-else-if="info.name">
      <div class="subTitle" v-if="info.name">
        <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
          {{g.isEn?info.nameEn:info.name}}
        </div>
      </div>
      <div class="subCompany">
        <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
          {{g.isEn?info.companyEn:info.company}}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="subTitle" v-if="info.theme">
        <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
          {{info.theme}}
        </div>
      </div>
      <div class="subCompany">
        <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
          {{g.isEn?info.companyEn:info.company}}
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import {createProp} from '@common/utils'
  import defaultImage from '../assets/images/默认的图标.png'
  import {liveStatusName} from "../../common/utils";

  export default {
    data() {
      return {defaultImage, showTitle: false}
    },
    props: {
      history: createProp([Object, String, Boolean]),
      info: createProp([Object, String]),
      title: createProp([String]),
      name: createProp([String]),
      src: createProp([String], {
        default: ""
      })
    },
    methods: {
      liveStatusName: liveStatusName.bind(this)
    }
  }
</script>



// WEBPACK FOOTER //
// src/wenxing/components/videoImageWrapper.vue